// extracted by mini-css-extract-plugin
export default {"icon":"privacy_icon__Zcqjq","content_wrap":"privacy_content_wrap__-8c5a"};